import { EventType, IncrementalSource } from '@rrweb/types';
import type { eventWithTime } from '@rrweb/types';

export function isMouseInteraction(event: eventWithTime): boolean {
    return event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseInteraction;
}
